const PLATFORM_STYLES: Record<string, string> = {
  airbnb: 'bg-rose-100 text-rose-800',
  hometogo: 'bg-cyan-100 text-cyan-800',
  booking: 'bg-blue-100 text-blue-800',
  'fewo-direkt': 'bg-violet-100 text-violet-800',
  travanto: 'bg-emerald-100 text-emerald-800',
  agoda: 'bg-orange-100 text-orange-800',
  housinganywhere: 'bg-fuchsia-100 text-fuchsia-800',
  unknown: 'bg-gray-100 text-gray-700',
  merged: 'bg-gray-100 text-gray-700',
};

const PLATFORM_LABELS: Record<string, string> = {
  airbnb: 'Airbnb',
  hometogo: 'HomeToGo',
  'fewo-direkt': 'FeWo-direkt',
  booking: 'Booking.com',
  travanto: 'Travanto',
  agoda: 'Agoda',
  housinganywhere: 'HousingAnywhere',
  unknown: 'Unbekannt',
  merged: 'Zusammengeführt',
};

export default function PlatformBadges({
  platforms,
  fallback,
  small = true,
}: {
  platforms?: string[];
  fallback?: string;
  small?: boolean;
}) {
  const values = platforms?.length ? platforms : fallback ? [fallback] : [];
  const sizeClass = small ? 'px-1.5 py-0.5 text-[10px]' : 'px-2.5 py-0.5 text-xs';

  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      {values.map((platform, index) => {
        const key = platform.trim().toLowerCase();
        const colorClass = PLATFORM_STYLES[key];
        // Keep new providers consistently colored without depending on row order.
        const hue = Array.from(key).reduce((hash, char) => (
          (hash * 31 + char.charCodeAt(0)) >>> 0
        ), 0) % 360;
        return (
          <span
            key={`${key}-${index}`}
            className={`inline-flex items-center rounded-full font-medium ${sizeClass} ${colorClass ?? ''}`}
            style={colorClass ? undefined : {
              backgroundColor: `hsl(${hue} 70% 94%)`,
              color: `hsl(${hue} 65% 28%)`,
            }}
          >
            {PLATFORM_LABELS[key] ?? platform}
          </span>
        );
      })}
    </span>
  );
}